import { render, staticRenderFns } from "./triple_arrow_button.vue?vue&type=template&id=63740132&"
import script from "./triple_arrow_button.vue?vue&type=script&lang=js&"
export * from "./triple_arrow_button.vue?vue&type=script&lang=js&"
import style0 from "./triple_arrow_button.vue?vue&type=style&index=0&id=63740132&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports